import React, { useEffect } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const PrivateRoute = () => {
  const { isAuthenticated, loading, checkSession } = useAuth();
  const location = useLocation();

  useEffect(() => {
    let active = true;

    const verifyRouteSession = async () => {
      if (active) {
        await checkSession();
      }
    };

    verifyRouteSession();

    return () => {
      active = false;
    };
  }, [checkSession, location.pathname]);

  if (loading && !isAuthenticated) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'background.default',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!loading && !isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
};
